<template>
  <header class="hero is-dark">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          Text Replacer
        </h1>
        <h2>
          Useful for deciphering texts where single characters were substituted by others
        </h2>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PageHeader'
}
</script>
